module.exports = __webpack_public_path__ + "img/book_01.241d04a4.png";